import { Box, Typography, Button } from "@mui/material";
import logo from "assets/logo_verify.svg";
import { useNavigate } from "react-router-dom";

/**
 * Component to show submit exit page
 */
export const FormSuccess = () => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate("/login");
  };

  return (
    <>
    <Box
    sx={{
      width: "40%",
      marginBottom: "3rem",
      "@media (min-width:900px)": {
        width: "90%", // Para md
      },
      "@media (min-width:1200px)": {
        width: "80%",
      },
      "@media (min-width:1536px)": {
        width: "70%", // Para xl
      },
    }}
  >
    <img src={logo} className="img-responsive" alt="Logo" />
  </Box>
  <Box sx={{ width: "100%" }}>
      <Typography
        component="h1"
        color="primary"
        sx={{
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "1.8125rem",
          textAlign: "center",
          width: "100%",
          mb: ".3rem",
          fontSize: { xs: "1.4rem", xl: "1.4rem" },
        }}
      >
        Usuario verificado
      </Typography>
      <Typography
        variant="body1"
        component="h2"
        sx={{
          color: "#A7ABBB",
          mb: 4,
          textAlign: "center",
          fontSize: { xs: ".8rem", xl: ".8rem" },
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "0.9375rem" /* 93.75% */,
        }}
      >
        Tu cuenta ha sido verificada. Ya puedes iniciar sesión.
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "2rem",
        }}
      >
        <Button
          variant="contained"
          sx={{ mt: 3, width: "100%" }}
          disableElevation
          type="submit"
          onClick={onClickHandler}
          
        >
          Iniciar sesión
        </Button>
      </Box>
      </Box>
    </>
  );
};
